// imported FIRST by bootstrap.tsx (right after the demo's preload): a module that has this imported before it sees the viewer's window height from its very first read
import { installShareViewport } from "./shareViewport";

installShareViewport();
